import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import { LoginDatos, LugarConfiguracionEmail } from '@/objects/User';

import { Card } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import CheckBoxCustom from '@/components/elements/Checkbox';
import Boton from '@/components/elements/Boton';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import { useServices } from '@/context/ServicesProvider';
import { mostrarAlerta } from '@/context/UtilsContext';
import { refrescarDatosUsuarioLogin } from '@/util/LocalStorageLoaded';
import { subtitulo } from '@/constants/Dimens';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    datosUsuario: LoginDatos | null;
    setDatosUsuario: React.Dispatch<React.SetStateAction<LoginDatos | null | undefined>>;
}

const DatosEmailGeneral: React.FC<Props> = ({ datosUsuario, setDatosUsuario }) => {

    const { usersQueries } = useServices();

    const [avisos_generales, setAvisosGenerales] = React.useState<boolean>(false);

    const { t } = useTranslation();

    useEffect(() => {
        setAvisosGenerales(datosUsuario?.aviso_email_general! == 1);
    }, [datosUsuario]);


    function guardarDatos() {
        usersQueries?.guardarEmailsGeneral(datosUsuario?.id_user!, avisos_generales ? 1 : 0, LugarConfiguracionEmail.PERFIL).then((response) => {
            if (datosUsuario) {
                datosUsuario.aviso_email_general = avisos_generales ? 1 : 0;
                setDatosUsuario(datosUsuario);
            }
            mostrarAlerta({
                title: t('common:opciones.informacion'),
                content: t("menu:secciones.ajustes_perfil.datos_actualizados_correctamente"),
                showCancelButton: false,
            });
            usersQueries?.obtenerDatosUsuario().then((response) => {
                if (response.data) {
                    refrescarDatosUsuarioLogin(response.data);
                }
            }
            );
        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
            <TituloSeccionH2 fontSize={subtitulo} texto={t("menu:secciones.ajustes_perfil.datos_news")} />
            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", alignItems: 'center', }}>
                <Card style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    alignItems: 'center', gap: '5px', padding: "20px", width: "100%"
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                        <CheckBoxCustom idCheck='avisos_noticias_ofertas' label={t("menu:secciones.ajustes_perfil.avisos_noticias_ofertas")} isChecked={avisos_generales} onCheckChange={setAvisosGenerales} />
                    </div>
                    <Boton fullWidth startIcon={<BrowserUpdatedIcon />} texto={t("menu:secciones.ajustes_perfil.actualizar_datos")} onClick={() => guardarDatos()} />
                </Card>
            </div>
        </section>
    );
}

export default DatosEmailGeneral;
